import { render, staticRenderFns } from "./addSticky.vue?vue&type=template&id=fd9b9e46&"
import script from "./addSticky.vue?vue&type=script&lang=js&"
export * from "./addSticky.vue?vue&type=script&lang=js&"
import style0 from "./addSticky.vue?vue&type=style&index=0&id=fd9b9e46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports